import React from "react";
import { useState, useEffect } from 'react';
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {isAuth} from "../../auth";
import {envLoader} from "../../../env/envLoader";
import axios from "axios";
import { useHistory } from "react-router-dom";
import "./CampaignSelector.scss";


const baseUrl = envLoader().base_url;

let CampaignSelector = (props) => {

    const {user} = props;

    const [campaigns, setCampaigns] = useState([]);
    const [selectedCampaign, setSelectedCampaign] = useState("");
    const [loading, setLoading] = useState(false);

    const history = useHistory();
    

    useEffect(() => {
        
        axios.get(`${baseUrl}campaignSelector/getCampaigns`, {withCredentials: true})
        .then(response => {
            let numberCampaigns = response.data.data.length;
            if(numberCampaigns < 2) {
               history.push("/");
            }
            setCampaigns(response.data.data);
        })
        .catch(err => console.error(err));
    }, []);

    const enviarCampania = () => {
        
        if (!selectedCampaign) {
            alert("Debe seleccionar una campaña");
            return;
        }

        setLoading(true);

        axios.post(
            `${baseUrl}campaignSelector/selectCampaign`,
            { campaignId: selectedCampaign },
            { withCredentials: true }
        ).then(() => {
           history.push("/loginAction");
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    };
    
    return (
        <div className="selector-container">
            <h2 className="selector-title">Seleccione una campaña</h2>
            <hr className="selector-line"/>
            <br></br>

            {campaigns.length > 0 ? (
                <>
                    <select class="nice-select"
                        value={selectedCampaign}
                        onChange={(e) => setSelectedCampaign(e.target.value)}>
                        <option value="">Seleccione una opción</option>

                        {campaigns.map(c => (
                            <option key={c.id} value={c.id}>
                                {c.description}
                            </option>
                        ))}
                    </select>

                    <br /><br />
                    <button className="confirm-btn" onClick={enviarCampania} disabled={loading}>
                        {loading ? "Accediendo..." : "Acceder"}
                    </button>
                </>
            ) : (
                <p>Cargando campañas...</p>
            )}
        </div>
    )
}


const mapPropsToState = state => {
    return {error: state.login.error, user: state.user}
}

CampaignSelector = connect(mapPropsToState,null)(CampaignSelector);
export default CampaignSelector;